/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let presentationApiUrl = root.presentationApiUrl.link;
let getPresentationListApiUrl = root.getPresentationListApiUrl.link;
let deletePresentationApiUrl = root.deletePresentationApiUrl.link;
let getAllDemoRequestListApiUrl = root.getAllDemoRequestListApiUrl.link;
let updateDemoReqInfoApiUrl = root.updateDemoReqInfoApiUrl.link;
let removeDemoReqApiUrl = root.removeDemoReqApiUrl.link;
let demoFeedbackRequestApiUrl = root.demoFeedbackRequestApiUrl.link;
let getAllDemoFeedbackListApiUrl = root.getAllDemoFeedbackListApiUrl.link;
let getAllFAQFeedbackListApiUrl = root.getAllFAQFeedbackListApiUrl.link;


export default {
  state: {
    getPresentationListState:{},
    getAllDemoRequestListState:{},
    getCompletedAllDemoRequestListState:{},
    getAllDemoFeedbackListState:{},
    getAllFAQFeedbackListState:{}
  },
  mutations: {
    getPresentationListMutation(state, value) {
      Vue.set(state, 'getPresentationListState', value);
    },
    getAllDemoRequestListMutation(state, value) {
      Vue.set(state, 'getAllDemoRequestListState', value);
    },
    getCompletedAllDemoRequestListMutation(state, value) {
      Vue.set(state, 'getCompletedAllDemoRequestListState', value);
    },
    getAllDemoFeedbackListMuatation(state, value) {
      Vue.set(state, 'getAllDemoFeedbackListState', value);
    },
    getAllFAQFeedbackListMutation(state, value) {
      Vue.set(state, 'getAllFAQFeedbackListState', value);
    }
  },
  actions: {
    // Get All Demo Feedback List Action
    getAllFAQFeedbackListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getAllFAQFeedbackListApiUrl).then(res => {
              context.commit('getAllFAQFeedbackListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get All Demo Feedback List Action
    getAllDemoReqFeedbackListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getAllDemoFeedbackListApiUrl).then(res => {
              context.commit('getAllDemoFeedbackListMuatation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Demo Feedback Request Action
    demoFeedbackRequestAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(demoFeedbackRequestApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Delete Demo Request From List Action
    deleteDemoRequestByIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(removeDemoReqApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update All Demo Request List Action
    updateDemoReqInfoAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(updateDemoReqInfoApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Completed All Demo Request List Action
    getCompletedAllDemoRequestListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getAllDemoRequestListApiUrl  + '?is_completed=True&&page_size=12').then(res => {
              context.commit('getCompletedAllDemoRequestListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get All Demo Request List Action
    getAllDemoRequestListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getAllDemoRequestListApiUrl  + '?page_size=12').then(res => {
              context.commit('getAllDemoRequestListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Delete Presentation List Action
    deletePresentationListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(deletePresentationApiUrl + '?title=' + payload.title).then(res => {
              context.commit('getPresentationListMutation', res);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Presentation List Action
    getPresentationListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getPresentationListApiUrl).then(res => {
              context.commit('getPresentationListMutation', res);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Post Presentation List Action
    postPresentationListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(presentationApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    }
  },
  getters: {
    getPresentationListGetter: state => state.getPresentationListState,
    getAllDemoRequestListGetter: state => state.getAllDemoRequestListState,
    getCompletedAllDemoRequestListGetter: state => state.getCompletedAllDemoRequestListState,
    getAllDemoFeedbackListGetter: state => state.getAllDemoFeedbackListState,
    getAllFAQFeedbackListGetter: state => state.getAllFAQFeedbackListState
  }
}